export class Coordinate {
  x: number;
  y: number;
  
  constructor(xIn: number, yIn: number) {
    this.x = xIn;
    this.y = yIn;
  }
}